const generic = {
  init : () => {
    generic.events();
  },
  events : () => {}
}

const pdp = {
  init : () => {
    pdp.events();
  },
  events : () => {
    $('.variation-select-form label[for="quantity"] button').on('click tap', function(e) {
      e.preventDefault();
      const qtyField = $('.variation-select-form label[for="quantity"] input[type="number"]'); 

      let qty = parseInt(qtyField.val());
      if($(this).data('increment')) qty++;
      else qty--;

      if(qty < 1) qty = 1; 
      if(qty > qtyField.attr('max')) qty = parseInt(qtyField.attr('max')); 

      qtyField.val(qty);
    });

    $('.variation-select-form span.vars label').on('click tap', function() {
      $('.variation-select-form span.vars label').removeClass('selected');
      $(this).addClass('selected');

      const price = $(this).data('price');
      $('.variation-select-form button[type="submit"]').find('.price').text(price);

      const max = $(this).data('qty');
      $('.variation-select-form input[name="quantity"]').attr('max', max);

      $('.variation-select-form input[name="quantity"]').val(1);
    });

    $('.variation-select-form').on('submit', function(e) {
      e.preventDefault();

      const form = $(this);
      form.addClass('loading');
      
      let item = {};
      form.serializeArray().map((i) => item[i.name] = i.value);

      const data = {
        'items' : [item]
      }
      
      $.ajax({
        url: window.Shopify.routes.root + 'cart/add.js',
        type: 'POST',
        data: data,
        success: function(data) {
          form.removeClass('loading');
          form.addClass('complete');

          setTimeout(() => {
            form.removeClass('complete');
          }, 2000);
        },
        error: function(data) {
          form.removeClass('loading');
        }
      });
    });

    $(document).on('click tap', '.variation-select-form .dropdown .selected a', function(e) {
      e.preventDefault();
      $('.variation-select-form .dropdown').toggleClass('open');
    });

    $(document).on('click tap', function(e) {
      var container = $(".variation-select-form .dropdown");
      if (!container.is(e.target) && container.has(e.target).length === 0) {
          container.removeClass('open');
      }
    });
  }
}

var search = {
  call: null,
  init : () => {
    search.events();
    search.checkFormSearchParam();
  },

  checkFormSearchParam: () => {
    //if url of the page has a search param ?q=blah then set 'blah' as the value of the search form
    const urlParams = new URLSearchParams(window.location.search);
    if(urlParams.has('q')) {
      const searchValue = urlParams.get('q');
      $('#header-search form .live-search-form-field').val(searchValue);
    }
  },

  events : () => {
    $(document).on('click tap', '.site-header-mobile-search-button', function(e) {
      e.preventDefault();
      $('#header-search').addClass('show');
    });

    $(document).on('focus', '#header-search form .live-search-form-field', function() {
      search.toggleSearchResults(true);
    });

    $(document).on('click tap keyup', '#header-search form .live-search-form-field', function() {
      // if count of characters is 1 or above, hide temp-results and show live-search-results
      const searchResults = $('#header-search form .live-search-results');
      if($(this).val().length > 0) {
        search.submitSearch();
        searchResults.find('.temp-results').removeClass('show');
        searchResults.find('.live-search-results-content').show();
      } else {
        searchResults.find('.temp-results').addClass('show');
        searchResults.find('.live-search-results-content').hide();
      }
    });

    $(document).on('click tap', function(e) {
      // if youre note clicking on the search form or any of its children, hide the search results
      if(!$(e.target).closest('#header-search form').length) {
        search.toggleSearchResults(false);
      }
    });
  },

  toggleSearchResults: (show = null) => {
    const searchResults = $('#header-search form .live-search-results');
    if((show == null || show == false) && searchResults.is(':visible')) {
      searchResults.slideUp();
    } else {
      searchResults.slideDown();
    }
  },

  submitSearch : () => {
    const form = $('#header-search form');

    if(search.call) {
      search.call.abort();
    }

    var params = '?' + form.serialize() + '&section_id=predictive-search';
    search.call = $.ajax({
      url: '/search/suggest' + params,
      type: 'GET',
      beforeSend: () => {
        $('#header-search form .live-search-results-content').html('<p class="loader">Fetching results...</p>').show();
      },
      success: (data) => {
        $('#header-search form .live-search-results-content').html(data);
      },
      complete: () => {
        search.call = null;
      }
    });
  }
}

jQuery(() => {
  generic.init();
  search.init();
  if($('body.template-product').length) pdp.init();
});